export enum MapStyles {
  Satellite = 'mapbox://styles/matt-hc/cj6fc91dr1sma2smhcq9qckg8?optimize=true',
  'hc-muted' = 'mapbox://styles/matt-hc/cjnute79e53qp2sp99szmei5u?optimize=true',
  ComeHome = 'mapbox://styles/matt-hc/cjnute79e53qp2sp99szmei5u',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Default = 'mapbox://styles/matt-hc/cjnute79e53qp2sp99szmei5u',
  Light = 'mapbox://styles/mapbox/light-v10',
  Print = 'mapbox://styles/matt-hc/ck6jt4zk804am1ipg196286d3?optimize=true',
}
